<template>
  <transition name="fade">
    <router-view/>
  </transition>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #4165d7;
  margin-top: 60px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue